import Img from "react-cloudimage-responsive";
import Link from "next/link";
import { useEffect, useState } from "react";
import {
  CheckWithPrefix,
  CheckWithPrefixResponse,
} from "lib/infomation_vender/document";

interface Slides {
  pic: string;
  bg: string;
  location: string;
  isEnable: boolean;
}

function CampGameReconmmend() {
  const [information, setinformation] = useState<CheckWithPrefixResponse>();

  useEffect(() => {
    const infomations = CheckWithPrefix({ host: window.location.hostname });
    setinformation(infomations);
  }, []);

  const slides: Slides[] = [
    {
      pic: "lottohot-logo4.png",
      bg: "shadow border-radius fade-color-blue",
      location: "/camps/lottohot",
      isEnable: information?.isLottohot ?? false,
    },
    {
      pic: "sabobet-snam-4.png",
      bg: "shadow border-radius fade-color-blue",
      location: "/camps/sbobet_sport",
      isEnable: true,
    },
    {
      pic: "sa-gaming-ufamobile-casino.png",
      bg: "shadow border-radius fade-color-blue",
      location: "/camps/sa_gaming",
      isEnable: true,
    },
    {
      pic: "ufabet-casino.png",
      bg: "shadow border-radius fade-color-blue",
      location: "/camps/ufabet",
      isEnable: information?.isufabet ?? false,
    },
    {
      pic: "sexygaming-ufamobile-casino.png",
      bg: "shadow border-radius fade-color-blue",
      location: "/camps/sexy_gaming",
      isEnable: true,
    },
    {
      pic: "yl-snam-white.png",
      bg: "shadow border-radius fade-color-blue",
      location: "/camps/yl_gaming",
      isEnable: true,
    },
    {
      pic: "pg-ufamobile-casino.png",
      bg: "shadow border-radius fade-color-blue",
      location: "/camps/pg_gaming",
      isEnable: true,
    },
    {
      pic: "ygg-ufamobile-casino.png",
      bg: "shadow border-radius fade-color-blue",
      location: "/camps/ygg_gaming",
      isEnable: true,
    },
    {
      pic: "pragmatic-ufamobile-casino.png",
      bg: "shadow border-radius fade-color-blue",
      location: "/camps/pragmatic_live_casino",
      isEnable: true,
    },
    {
      pic: "joker-ufamobile-casino.png",
      bg: "shadow border-radius fade-color-blue",
      location: "/camps/joker_gaming",
      isEnable: true,
    },
    {
      pic: "dragonsoft-snam-2.png",
      bg: "shadow border-radius fade-color-blue",
      location: "/camps/dragoon_gaming",
      isEnable: true,
    },
    {
      pic: "fachai-casino.png",
      bg: "shadow border-radius fade-color-blue",
      location: "/camps/fachai_gaming",
      isEnable: true,
    },
    {
      pic: "asia-gaming-snam.png",
      bg: "shadow border-radius fade-color-blue",
      location: "/camps/asia_gaming",
      isEnable: true,
    },
    {
      pic: "ebet-casino.png",
      bg: "shadow border-radius fade-color-blue",
      location: "/camps/ebet_casino",
      isEnable: true,
    },
    {
      pic: "jdb-casino.png",
      bg: "shadow border-radius fade-color-blue",
      location: "/camps/jdb_gaming",
      isEnable: true,
    },
    {
      pic: "kingmaker-casino-slot.png",
      bg: "shadow border-radius fade-color-blue",
      location: "/camps/kingmaker_gaming",
      isEnable: true,
    },
    {
      pic: "redtiger-casino.png",
      bg: "shadow border-radius fade-color-blue",
      location: "/camps/redtiger_gaming",
      isEnable: true,
    },
    {
      pic: "bng-casino.png",
      bg: "shadow border-radius fade-color-blue",
      location: "/camps/bng_gaming",
      isEnable: true,
    },
    {
      pic: "onegame-casino.png",
      bg: "shadow border-radius fade-color-blue",
      location: "/camps/onegame_gaming",
      isEnable: true,
    },
    {
      pic: "jili-casino.png",
      bg: "shadow border-radius fade-color-blue",
      location: "/camps/jili_gaming",
      isEnable: true,
    },
  ];

  return (
    <div style={{ marginTop: 20 }}>
      <h4>ค่ายแนะนำ</h4>
      <div
        style={{
          overflowY: "scroll",
          height: 100,
        }}
      >
        {slides.map((el, i) => {
          if (!el.isEnable) {
            return <></>;
          }

          return (
            <th key={i}>
              <Link href={el.location}>
                <a>
                  <div style={{ height: 100, width: 100, marginRight: 20 }}>
                    <div
                      className={el.bg}
                      style={{
                        paddingTop: 20,
                        paddingBottom: 20,
                      }}
                    >
                      <Img ratio={2 / 1} src={el.pic ?? ""} alt={el.pic}></Img>
                    </div>
                  </div>
                </a>
              </Link>
            </th>
          );
        })}
      </div>
    </div>
  );
}

export default CampGameReconmmend;
